import { formatDateLong } from '@/lib/format-date';

/**
 * The shutoff date as display text — but only while it is still AHEAD.
 *
 * Both the banner and the popup say "update your card by {{date}}". A shutoff
 * date that has already passed (the episode moved on, or a stale value) rendered
 * as "Update your card by 16 March" in April: a deadline that is over, stated as
 * one still to meet. A past or unreadable date returns '' so the caller falls back
 * to its undated copy.
 */
export function upcomingShutoffText(
  shutoffAt: string | Date | null | undefined,
  now: Date = new Date(),
): string {
  if (!shutoffAt) return '';
  const at = new Date(shutoffAt);
  if (Number.isNaN(at.getTime()) || at.getTime() <= now.getTime()) return '';
  // Local time on purpose: staff-app writes shutoffAt as an instant (episode start, i.e.
  // the moment the ladder opened, plus N days), not a UTC-midnight calendar date.
  return formatDateLong(shutoffAt as string);
}
